import styles from "./GivenSection.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Expander } from "shared/components/Expander/Expander";
import { AddButton } from "shared/components/AddButton/AddButton";
import { useTranslation } from "react-i18next";
import { Button } from "@wwg/ui";

/**
 * Expandable section to track BSMs given to a Prospect.
 */
export function GivenSection({ title, isOpen, onAdd, children }) {
  const { t } = useTranslation();

  return (
    <Expander
      toggleOnClick={false}
      isOpen={isOpen}
      renderHeader={(open, setOpen) => (
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>

          {open ? (
            <Button
              style={{
                padding: 0,
              }}
              buttonStyle="borderless"
              onClick={() => {
                setOpen(false);
              }}
            >
              {t("buttons.cancel")}
            </Button>
          ) : (
            <AddButton
              onClick={() => {
                if (onAdd) {
                  onAdd(open, setOpen);
                } else {
                  setOpen(true);
                }
              }}
            >
              {t("buttons.add")}
            </AddButton>
          )}
        </div>
      )}
    >
      <div className={styles.content}>{children}</div>
    </Expander>
  );
}

GivenSection.propTypes = {
  /**
   * Title for the section header.
   */
  title: PropTypes.string.isRequired,

  /**
   * If passed, overrides the default action when the user clicks the "+ Add" button in the header.
   */
  onAdd: PropTypes.func,

  /**
   * Override open/closed state from outside.
   */
  isOpen: PropTypes.bool,
};
